import React from "react";
import PropTypes from "prop-types";

import { Graphics } from "./components/Graphics";

import "./style.scss";

export class CuvetteSeal extends React.Component {
  constructor(props){
    super(props)

    const interactions = (heldObj, target) => {
      //Don't run if this cuvetteSeal not the held object
      if(heldObj.type !== "CuvetteSeal" || heldObj.id !== this.props.id){
        return null;
      }
      if (target === undefined || target === null) {
        return null;
      }

      //All Cuvette interactions
      if (target.type === "Cuvette") {
        //Get the targeted GlassTube
        const cuvetteId = target.id

        const targetCuvette = this.props.interactionProps.cuvettes[cuvetteId - 1]

        if(targetCuvette.lidId !== -1) {
          //this.makeToast("WARNING", "This cuvette already contains a lid.", "Cuvette contains lid!");
          return null;
        }

        this.props.onDropCuvetteSeal({
          sealId: this.props.id,
          cuvetteId: targetCuvette.id,
          type: "cuvetteSeal"
        })

        this.props.setCuvetteSealsInScene({
          id: this.props.id,
          inScene: false
        });

        // Reset the tube position to a zero transform
        heldObj.htmlObj.style.transform = "translate3d(0px,0px,0px) rotateZ(0deg)"

        // if(targetCuvette.open) {
        //   targetCuvette.onDropItem(this.props.id);

        // } else {
        //   this.makeToast("WARNING", "You must open the glass tube first.", "Glass Tube is closed!")
        // }
      } else {
        return null
      }
    }
    Object.defineProperty(interactions, 'name', {value: ('cuvetteSeal_interactions_'+this.props.id), configurable: true});
    this.props.pushInteractions([interactions])
  }



  componentWillMount() {
    this.props.createCuvetteSeal({
      props: this.props.defaultProps,
    });
  }
  cuvetteSealSelected = (e) => {

    this.props.setCuvetteSealHeld({
      id: this.props.id,
      held: true,
    })
    this.props.setHeldObject({
      id: this.props.id,
      type: "CuvetteSeal",
      htmlObj: e.target,
    });
    if(!this.props.controlsVisible){
      this.showControls()
  }
  }

  cuvetteSealUnselected = (e) => {
    this.props.setCuvetteSealHeld({
      id: this.props.id,
      held: false,
    })
  }

  showControls = ()=> {
    this.props.hideAllControls();
    this.props.setCuvetteSealControlVisibility({id: this.props.id, controlsVisible: true});
  }

  render() {
    return (
      <ul style={{
        visibility: !this.props.inScene ? "hidden" : null,
        zIndex: this.props.controlsVisible ? 99 : null,
      }}>
        <li
          id={"CuvetteSeal_"+this.props.id}
          className={'CuvetteSeal draggable'}
          onKeyDown={ (e)=>{if(e.keyCode === 13 || e.keyCode === 32) this.cuvetteSealSelected() } }
          onDragStart={(e) => this.cuvetteSealSelected(e)}
          onDragEnd={(e) => this.cuvetteSealUnselected(e)}
          draggable
          tabIndex={0}
          style={{ transform: "translate3d(0px, 0px, 0px) rotateZ(0deg)" }}>
          <Graphics id={this.props.id}/>
        </li>
      </ul>
    );
  }
}

CuvetteSeal.propTypes = {
  createCuvetteSeal: PropTypes.func,
};

CuvetteSeal.defaultProps = {};
